import { getAPIURL } from '../../GlobalComponents/URLs'

// export interface FetchCustomerTagsPayload {
//     allSites?: boolean
//     assetType: any
//     entities?: any[]
//     tagUID: number[]
// }

// export interface FetchCustomerTagsReturnPayload {
//     CustomerTags: any[]
//     ServiceTypes: any[]
//     AssetFields: any[]
// }

// export const fetchCustomerTags = async (payload: FetchCustomerTagsPayload) => {
//     let url = getAPIURL() + 'lcm/customertags'
//     let req = await fetch(url, {
//         credentials: 'include',
//         method: 'POST',
//         headers: { 'Content-Type': 'application/json' },
//         body: JSON.stringify(payload),
//     })
//         .then((resp) => {
//             if (resp.ok) {
//                 return resp.json()
//             } else throw new Error('bad request ' + resp.statusText)
//         })
//         .catch((err) => {
//             console.error('Error fetching customer tags')
//         })

//     let json: FetchCustomerTagsReturnPayload = await req

//     return json
// }

export interface FetchCustomerTagsSearchPayload {
    inputValue: string
    maxReturnedBytes: number
    selectedValue: ''
}

export interface FetchCustomerTagsSearchReturnPayload {
    AssetType: string
    SerialNumber: string
    Tag: string
    TagUID: number
    ValveManufacturer?: string
    ValveModelNo?: string
}

export const fetchCustomerTagsSearch = async (payload: FetchCustomerTagsSearchPayload) => {
    let url = getAPIURL() + 'lcm/taguids'
    let req = await fetch(url, {
        credentials: 'include',
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload),
    })
        .then((resp) => {
            if (resp.ok) {
                return resp.json()
            } else throw new Error('bad request ' + resp.statusText)
        })
        .catch((err) => {
            console.error('Error fetching customer tags')
        })

    let json: FetchCustomerTagsSearchReturnPayload[] = await req

    return json
}
